export default __webpack_public_path__ + "d494ffec00f355a0ddf2891526d154c8.png";